<p>post-sign-out works!</p>
